import { dict } from "..";
import { useInView } from "../../../hooks/useInView";
import { Language } from "../../../types";

interface Props {
  keyValue: "t1" | "t2" | "t3" | "t4" | "t5";
  icon: string;
  alt: string;
  language: Language;
}

const triggerOnce = true;

export const Item: React.FC<Props> = ({ keyValue, icon, alt, language }) => {
  const { ref, isInView } = useInView({ threshold: 0.5 }, triggerOnce);

  return (
    <article ref={ref} className={isInView ? "inView" : ""}>
      <img height={50} width={50} src={icon} alt={alt} />
      <div>{dict[language][keyValue]}</div>
    </article>
  );
};
